export const getServerRuntimeConfig = () => {
    var _a, _b, _c, _d;
    return {
        DTN_APP_DOMAIN: (_a = process.env.DTN_APP_DOMAIN) !== null && _a !== void 0 ? _a : "",
        DTN_CLIENT_ID: (_b = process.env.DTN_CLIENT_ID) !== null && _b !== void 0 ? _b : "",
        DTN_CLIENT_SECRET: (_c = process.env.DTN_CLIENT_SECRET) !== null && _c !== void 0 ? _c : "",
        DTN_AUTH_URL: process.env.DTN_AUTH_URL,
        DTN_AUTH_AUDIENCE: process.env.DTN_AUTH_AUDIENCE,
        DTN_AUTH_INFO_URL: process.env.DTN_AUTH_INFO_URL,
        DTN_IDENTITY_HOST: process.env.DTN_IDENTITY_HOST,
        DTN_IDENTITY_AUDIENCE: process.env.DTN_IDENTITY_AUDIENCE,
        SENDGRID_API: (_d = process.env.SENDGRID_API) !== null && _d !== void 0 ? _d : "",
        APP_BASE_PATH: process.env.APP_BASE_PATH,
    };
};
/**
 * Returns public runtime config values.
 * On the client, reads from window.__ENV__ (injected by the app's _document.tsx or layout.tsx).
 * On the server, reads from process.env.
 */
export const getPublicRuntimeConfig = () => {
    var _a;
    if (typeof window !== "undefined" &&
        window.__ENV__ !== undefined) {
        const env = window
            .__ENV__;
        return {
            DTN_PRODUCT_CODE: env.DTN_PRODUCT_CODE,
        };
    }
    return {
        DTN_PRODUCT_CODE: (_a = process.env.NEXT_PUBLIC_DTN_PRODUCT_CODE) !== null && _a !== void 0 ? _a : process.env.DTN_PRODUCT_CODE,
    };
};
